export default __webpack_public_path__ + "static/media/computerlab2.604c5696.jpg";